import types from "./types";
import axios from "@/helpers/axios";

export default {
  [types.FETCH_PRODUCT_SCHEDULE]: async ({ commit }, productId) => {
    commit(types.FETCH_PRODUCT_SCHEDULE, []);
    if (productId) {
      return await axios.get(`/products/${productId}`).then(async response => {
        let scheduleId = response.data.data.scheduleId;
        await axios.get(`/schedules/${scheduleId}`).then(response => {
          if (response.data.data) {
            let { ScheduleMeta } = response.data.data;
            commit(types.FETCH_PRODUCT_SCHEDULE, ScheduleMeta);
          }
        });
      });
    }
  },
  copyScheduleData: ({ commit }, data) => {
    commit(types.UPDATE_COPY_SCHED, data);
  }
};
